define('TescoMobile_Iovation/js/action/wait-for-device-fingerprint',['jquery', './set-device-fingerprint', './get-device-fingerprint', '../model/device-fingerprint-config'], function ($, setDeviceFingerPrint, getDeviceFingerPrint, fingerprintConfig) {
  'use strict';

  const maxRetries = fingerprintConfig.maxRetries,
    retryInterval = fingerprintConfig.retryInterval;
  return function (_ref) {
    let deviceFingerprintUrl = _ref.deviceFingerprintUrl,
      callback = _ref.callback,
      callbackArguments = _ref.callbackArguments;
    const deferred = $.Deferred();
    let retries = 0;
    function checkFunction() {
      const result = getDeviceFingerPrint();
      if (result !== null) {
        setDeviceFingerPrint(deviceFingerprintUrl, result).done(function () {
          callback(...callbackArguments).done(function (response) {
            deferred.resolve(response);
          });
        });
      } else {
        retries++;
        if (retries >= maxRetries) {
          deferred.reject(new Error("Max retries exceeded"));
        } else {
          setTimeout(checkFunction, retryInterval);
        }
      }
    }
    checkFunction();
    return deferred.promise();
  };
});

